import React, { useState, useEffect, useRef, useCallback } from "react";
import "./TaxiImages.css";

const TaxiImages = ({ images }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const galleryRef = useRef(null);
    let touchStartX = useRef(null);
    
    const allImages = images || [];
    const galleryImages = allImages.slice(0, 3);

    const openGallery = (index) => {
        setSelectedIndex(index);
        setIsOpen(true);
    };

    const closeGallery = (e) => {
        if (e.target.classList.contains("gallery-modal")) {
            setIsOpen(false);
        }
    };

    const nextImage = useCallback(() => {
        setSelectedIndex((prevIndex) => (prevIndex + 1) % allImages.length);
    }, [allImages.length]);

    const prevImage = useCallback(() => {
        setSelectedIndex((prevIndex) => (prevIndex - 1 + allImages.length) % allImages.length);
    }, [allImages.length]);

    const openRandomImage = () => {
        if (allImages.length > 0) {
            const randomIndex = Math.floor(Math.random() * allImages.length);
            setSelectedIndex(randomIndex);
            setIsOpen(true);
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        const handleTouchStart = (e) => {
            touchStartX.current = e.touches[0].clientX;
        };

        const handleTouchMove = (e) => {
            if (!touchStartX.current) return;
            const diff = e.touches[0].clientX - touchStartX.current;
            if (diff > 50) {
                prevImage();
                touchStartX.current = null;
            } else if (diff < -50) {
                nextImage();
                touchStartX.current = null;
            }
        };

        if (isOpen) {
            document.addEventListener("touchstart", handleTouchStart);
            document.addEventListener("touchmove", handleTouchMove);
            document.addEventListener("click", closeGallery);
        }

        return () => {
            document.removeEventListener("touchstart", handleTouchStart);
            document.removeEventListener("touchmove", handleTouchMove);
            document.removeEventListener("click", closeGallery);
        };
    }, [isOpen, nextImage, prevImage]);

    return (
        <div className="taxi-gallery-container">
            <div className="gallery-grid">
                <div className="large-image-container">
                    {galleryImages[0] && (
                        <img
                            src={galleryImages[0]}
                            alt="תמונה ראשית"
                            className="gallery-image large"
                            onClick={() => openGallery(0)}
                        />
                    )}
                </div>
                <div className="small-images-container">
                    {galleryImages.slice(1).map((image, index) => (
                        <img
                            key={index + 1}
                            src={image}
                            alt={`תמונה ${index + 2}`}
                            className="gallery-image small"
                            onClick={() => openGallery(index + 1)}
                        />
                    ))}
                </div>
            </div>
            {allImages.length > 3 && (
                <button className="show-all-button" onClick={openRandomImage}>
                    הצג את כל התמונות
                </button>
            )}
            
            {isOpen && (
                <div className="gallery-modal" ref={galleryRef}>
                    <img src={allImages[selectedIndex]} alt="תמונה מוצגת" className="modal-image" />
                    {!isMobile && (
                        <>
                            <button className="prev-btn" onClick={prevImage}>&lt;</button>
                            <button className="next-btn" onClick={nextImage}>&gt;</button>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default TaxiImages;